export const FORUM_RENAMED = 'settings/FORUM_RENAMED';
export const forumRenamed = () => ({
  type: FORUM_RENAMED,
});



// WEBPACK FOOTER //
// ./app-settings/actions/forum-renamed.js